import { render, staticRenderFns } from "./AutosaveInput.vue?vue&type=template&id=5a8ec6f3&scoped=true"
import script from "./AutosaveInput.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AutosaveInput.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./AutosaveInput.vue?vue&type=style&index=0&id=5a8ec6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ec6f3",
  null
  
)

export default component.exports